import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudTypographyModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { AccordionModule } from 'shared/components/accordion/accordion.module';

import { AppointmentDetailsTasksComponent } from './appointment-details-tasks.component';

@NgModule({
	declarations: [AppointmentDetailsTasksComponent],
	exports: [AppointmentDetailsTasksComponent],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		AccordionModule,
		FreudTypographyModule,
	],
})
export class AppointmentDetailsTasksModule {}
